// extracted by mini-css-extract-plugin
export default {"menu":"StatusMenu_menu__F6gsq","option":"StatusMenu_option__F-DMZ","menu_close":"StatusMenu_menu_close__7VUiB"};